import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/logo.png"
import { post } from "../../utils/helpers/http";
import { getLocalStorageData } from "../../utils/helpers/helpers";

const Header = () => {
  const navigate = useNavigate();
  const INACTIVITY_LIMIT = 24 * 60 * 60 * 1000; // 24 hours
  const ABSOLUTE_SESSION_LIMIT = 24 * 60 * 60 * 1000; // 24 hours

  const inactivityTimerRef = useRef(null);
  const absoluteTimerRef = useRef(null);

  useEffect(() => {
    const authToken = getLocalStorageData("authorizationToken");
    if (!authToken) {
      console.log("navigate to root")
      navigate("/");
      return;
    }

    const loginTime = localStorage.getItem("loginTime");
    const now = new Date().getTime();

    // If no login time, or if 24 hours have passed → logout.
    if (!loginTime || now - parseInt(loginTime) > ABSOLUTE_SESSION_LIMIT) {
      console.log("Absolute session expired");
      handleLogout();
      return;
    }

    // Set absolute logout timer
    const remainingSessionTime = Math.max(ABSOLUTE_SESSION_LIMIT - (now - parseInt(loginTime)), 0);
    absoluteTimerRef.current = setTimeout(() => {
      console.log("Logging out after 24 hours (absolute session limit)");
      handleLogout();
    }, remainingSessionTime);

    // Set inactivity logout timer
    resetInactivityTimer();

    // Listen to user activity
    const events = ["mousemove", "mousedown", "keypress", "touchstart", "scroll"];
    events.forEach((event) => window.addEventListener(event, resetInactivityTimer));

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetInactivityTimer));
      clearTimeout(inactivityTimerRef.current);
      clearTimeout(absoluteTimerRef.current);
    };
  }, []);

  const resetInactivityTimer = () => {
    clearTimeout(inactivityTimerRef.current);
    // Starts a new 30-minute timer every time the user is active.
    inactivityTimerRef.current = setTimeout(() => {
      console.log("Logging out after  24 hours of inactivity");
      handleLogout();
    }, INACTIVITY_LIMIT);
  };

  const handleLogout = async () => {
    try {
      const response = await post('/Account/Logout', { "a": "a" });
      if (response.status === 200) {
        localStorage.removeItem("accessToken")
        localStorage.removeItem("authorizationToken")
        localStorage.removeItem("userId")
        navigate("/");
      } else {
        if (response.response.status === 401) {
          navigate("/");
        }
      }
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/");
      }
    }
  };

  return (
    <nav className="navbar navbar-expand navbar-dark static-top">
      <div className="header-left">
        <span className="headerlogo">
          <img src={Logo} alt="logo" />
        </span>
        {/* <span className="main-header-menu-icon" id="sidebarToggle"><span></span></span> */}
      </div>
      <div className="header-right">
        <button className="logoutbtn" onClick={handleLogout}>Logout</button>
      </div>
    </nav>
  );
};

export default Header;
